import {AbstractEvent} from "@/modules/base/events";
import {Season} from "@/modules/season/entity";

export class BeforeSeasonEvaluationEvent extends AbstractEvent {
  constructor(
    public season: Season
  ) {
    super();
  }
}